export default "__VITE_ASSET__BWI7il67__"